// Compiled at 2026-05-13T13:50:05.286Z
// Auto-generated by Lowgile
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Llama, Llama as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import { BoInfoSymbol, OnAfterCodeLoad, HasChangedInternallySymbol } from "@lg/shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty } from "@sumbricht/json-class-serializer";
import { proxySignal, ProxySignal, signal, computed, Signal } from "../../signals.js";
import { HasSignalProperties } from "@lg/shared";
import { immerable } from "immer";
import { DataLoader } from "@lg/shared";
import { Subject } from "rxjs";
import { z } from "zod";
import { AppContext } from "@lg/ng-shared";
import { ChangeDetectorRef } from "@angular/core";

const θdataLoader =
    new DataLoader(() => Currency.loadInternal(), entryList => {
        Currency.θentryList.set(entryList)
        Currency.θonEntryListUpdated()
    }, { doCache: true, expireAfterMs: 0 })
    ;

// Auto-generated by Lowgile
export class Currency {
    readonly [BoInfoSymbol] = Object.freeze({
        boType: "StaticEntity" as const,
        editablePropertyNames: ["id"] as const,
        computedPropertyNames: ["label"] as const,
        allPropertyNames: ["id", "label"] as const,
        propertyNamesOfInterest: [] as const,
    });
    readonly [HasSignalProperties] = true;
    readonly [HasChangedInternallySymbol] = new Subject<void>();
    readonly θid: ProxySignal<Currency.Id>;
    static readonly Id = String;
    static θentryList = signal<ReadonlyArray<Currency.Entry> | undefined>(this.θgetStaticEntryList());
    static θentryMap = computed(() => {
        const objEntries = this.θentryList()?.map(e => [e.id, e]) ?? []
        return Object.freeze(Object.fromEntries(objEntries))
    });
    static θchoicesCache = new Map<string, Sys.Types.Choice[]>();
    static θfilteredCache = new Map<string, Signal<Currency.Entry[]>>();
    readonly θhasOthers = false;
    static readonly $displayProperty = 'label';
    [immerable] = true;
    readonly θlabel = computed(() => Currency.getEntryMap()[this.θid()]?.label);
    readonly $isOther = false;

    static get [BoInfoSymbol]() {
        return Currency[BoInfoSymbol]
    }

    get __type(): 'Llama.Currency' {
        return 'Llama.Currency'
    }

    set __type(_) {
    }

    static get __type(): 'Llama.Currency' {
        return 'Llama.Currency'
    }

    static set __type(_) {
    }

    @jsonProperty()
    get id() {
        return this.θid()
    }

    set id(id: Currency.Id) {
        if (id != null && !Currency.getEntry(id)) throw new Error('Invalid id for type Llama.Currency: ' + id)
        this.θid.set(id)
        this[HasChangedInternallySymbol].next()
    }

    get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    static get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    get $displayValue(): string {
        return this.$isOther ? (this as any).$other : String((this as any)[Currency.$displayProperty])
    }

    get label() {
        return this.θlabel()
    }

    get ischf() {
        return this.id == 'chf'
    }

    static get chf() {
        return new this('chf')
    }

    get iseur() {
        return this.id == 'eur'
    }

    static get eur() {
        return new this('eur')
    }

    get isusd() {
        return this.id == 'usd'
    }

    static get usd() {
        return new this('usd')
    }

    constructor(id: Currency.Id = null) {
        this.θid = proxySignal(id)

    }

    getEntryList(filters?: { entryProperty: string, values: any[] }[]) {
        return This.Currency.getEntryList(filters)
    }

    static getEntryList(filters?: { entryProperty: string, values: any[] }[]) {
        if (filters) {
            const key = JSON.stringify(filters)
            let filteredList = this.θfilteredCache.get(key)
            if (!filteredList) {
                filteredList = computed(() => this.θentryList()?.filter(entry => filters.every(filter => filter.values.includes(entry[filter.entryProperty]))) ?? [])
                this.θfilteredCache.set(key, filteredList)
            }

            return filteredList()
        }

        return this.θentryList()
    }

    static getEntryMap() {
        return this.θentryMap()
    }

    static getEntry(id: Currency.Id) {
        const entryMap = this.getEntryMap()
        return entryMap[id]
    }

    static getChoices(labelColumn: keyof Currency.Entry = '$displayValue'): Sys.Types.Choice[] {
        if (labelColumn == "$displayValue") labelColumn = Currency.$displayProperty
        let options = this.θchoicesCache.get(labelColumn)
        if (!options) {
            const entryList = this.getEntryList() ?? []
            options = entryList.map(entry => ({ id: entry.id, label: String(entry[labelColumn]), $isOther: false }))
            this.θchoicesCache.set(labelColumn, options)
        }

        return options
    }

    static async load(forceReload = false) {
        if (forceReload) {
            this.θentryList.set(await θdataLoader.forceReloadAndGetData())
        } else {
            this.θentryList.set(await θdataLoader.waitAndGetValidData())
        }

        this.θonEntryListUpdated()
        return this.θentryList()
    }

    static async loadInternal(): Promise<Currency.Entry[]> {
        const dynamicEntryList = []
        this.θchoicesCache.clear()
        return LowgileDataUtil.createReadonlyProxy(true, [...this.θgetStaticEntryList(), ...dynamicEntryList])
    }

    toJSON() {
        return this.id
    }

    $clone() {
        return new Currency(this.id)
    }

    $equals(other: any) {
        if (this.id !== other?.id) return false

        return true
    }

    θtoPlainObject() {
        return this.id
    }

    θupdate(idOrObject: Currency.Id | Currency) {
        if (idOrObject && typeof idOrObject == 'object') {
            this.id = idOrObject.id

        } else {
            this.id = idOrObject as any
        }
    }

    static θonEntryListUpdated() {
        AppContext.resolve(ChangeDetectorRef).detectChanges()
    }

    static async θafterCodeLoad() {
        return this.load().catch(err => {
            console.log('Could not load entries of StaticEntity Llama.Currency yet:', err.message)
            //throw err
        })
    }

    static $getSchema() {
        return z.string()
    }

    $getSchema() {
        return z.string()
    }

    setchf() {
        this.id = 'chf'

    }

    seteur() {
        this.id = 'eur'

    }

    setusd() {
        this.id = 'usd'

    }

    static θgetStaticEntryList() {
        return Object.freeze([
            Object.freeze({ id: "chf", label: "CHF" }),
            Object.freeze({ id: "eur", label: "EUR" }),
            Object.freeze({ id: "usd", label: "USD" })
        ])
    }
}
jsonClass('Llama.Currency')(Currency)

export const CurrencyθId = String;

export type CurrencyθId = string;

export namespace Currency {
    export type Id = 'chf' | 'eur' | 'usd'

    export interface Entry {
        id: string;
        label: string;
        $displayValue?: string;
    }
}
Sys.Language.languageChanged$.subscribe(() => Currency.load(true))
